import { BreakpointObserver } from '@angular/cdk/layout';
import { inject, Injectable, signal } from '@angular/core';
import { startWith } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  public isSidebarToggled = signal<boolean>(true);
  public mobileView = signal<boolean>(true);

  private breakpointObserver = inject(BreakpointObserver);

  constructor() {
    this.breakpointObserver
      .observe([
        '(max-width: 575px)',
        '(min-width: 576px) and (max-width: 1200px)',
      ])
      .pipe(startWith())
      .subscribe((result) => {
        if (result.breakpoints['(max-width: 575px)']) {
          this.isSidebarToggled.set(false);
          this.mobileView.set(true);
        } else if (
          result.breakpoints['(min-width: 576px) and (max-width: 1200px)']
        ) {
          this.isSidebarToggled.set(false);
          this.mobileView.set(false);
        } else {
          this.isSidebarToggled.set(true);
          this.mobileView.set(false);
        }
      });
  }
}
